// src/pages/Security.jsx
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Security = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Header />
      <section className="hero-section inner-page" id="hero-security">
        <div className="wave">
          <svg width="1920px" height="265px" viewBox="0 0 1920 265" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFFFFF">
              <path d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,667 L1017.15166,667 L0,667 L0,439.134243 Z"></path>
            </g>
          </svg>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="row justify-content-center">
                <div className="col-md-7 text-center hero-text" data-aos="fade-up">
                  <h1>Seguridad</h1>
                  <p className="mb-5">
                    Descubre cómo protegemos tus transacciones y datos personales en Smart Money.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <main id="main">
        <section className="section">
          <div className="container">
            <h2 className="mb-4 text-center">Medidas de Seguridad</h2>
            <p className="text-center mb-4">
              En Smart Money nos tomamos la seguridad muy en serio. Algunas de nuestras medidas incluyen:
            </p>
            <div className="list-group">
              <div className="list-group-item" data-aos="fade-up">
                <h5 className="mb-1"><strong>Encriptación de Datos:</strong></h5>
                <p className="mb-1">Toda la información transmitida se encripta utilizando protocolos seguros.</p>
              </div>
              <div className="list-group-item" data-aos="fade-up" data-aos-delay="100">
                <h5 className="mb-1"><strong>Autenticación de Usuarios:</strong></h5>
                <p className="mb-1">Utilizamos métodos de autenticación robustos para proteger las cuentas de usuario.</p>
              </div>
              <div className="list-group-item" data-aos="fade-up" data-aos-delay="200">
                <h5 className="mb-1"><strong>Transacciones Seguras:</strong></h5>
                <p className="mb-1">Aplicamos altos estándares de seguridad en cada operación para garantizar la integridad de los fondos.</p>
              </div>
              <div className="list-group-item" data-aos="fade-up" data-aos-delay="300">
                <h5 className="mb-1"><strong>Monitoreo y Prevención de Fraude:</strong></h5>
                <p className="mb-1">Contamos con sistemas de monitoreo continuo para detectar y prevenir actividades sospechosas.</p>
              </div>
              <div className="list-group-item" data-aos="fade-up" data-aos-delay="400">
                <h5 className="mb-1"><strong>Protección de Datos Personales:</strong></h5>
                <p className="mb-1">Tus datos se manejan con estrictos protocolos de privacidad y confidencialidad.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <style jsx>{`
        .list-group-item {
          transition: transform 0.3s ease, background-color 0.3s ease;
          cursor: pointer;
        }
        .list-group-item:hover {
          transform: translateY(-3px);
          background-color: #f8f9fa;
        }
      `}</style>
    </>
  );
};

export default Security;
